import { Dialog, DialogActions, DialogContent, TextField } from "@mui/material";
import { MprcDialogTitleClose, MprcSpinnerIndicator } from "components";
import { ButtonCancel, ButtonSend } from "components/buttons";
import { MprcRequestErrorReport } from "components/MprcRequestErrorReport";
import { StandardAccountSendResetPasswordStatus } from "generated/CoreApi_v1";
import { useSnackbar } from 'notistack';
import { useCoreApi } from "providers/CoreApiProvider";
import { useSession } from "providers/SessionProvider";
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////

type ForgotPassProps = {
    onClose: () => void;
};

export const ForgotPassDialog: React.FC<ForgotPassProps> = ({ onClose }) => {
    const [authValue, setAuthValue] = useState<string | undefined>(undefined);
    const [submiting, setSubmiting] = useState<boolean>(false);
    const [viewError, setViewError] = useState<any>();

    const api = useCoreApi();
    const session = useSession();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    ///
    const handleRenew = () => {
        setSubmiting(true);

        api.v1.account.standardAccountSendResetPassword({ authFieldValue: authValue! })
            .then((response) => {
                var result = response.data;

                switch (result.status) {
                    case StandardAccountSendResetPasswordStatus.NotFound:
                        enqueueSnackbar(t("Auth.Common.AccountNotFoundMessage"), { variant: "error" });
                        break;
                    case StandardAccountSendResetPasswordStatus.InvalidAuth:
                        enqueueSnackbar(t("Auth.Common.InvalidAuthMessageMessage"), { variant: "error" });
                        break;
                    case StandardAccountSendResetPasswordStatus.EmailNotSend:
                        enqueueSnackbar(t("Auth.ForgotPassDialog.EmailNotSendMessage"), { variant: "error" });
                        break;
                    case StandardAccountSendResetPasswordStatus.Done:
                        enqueueSnackbar(t("Auth.ForgotPassDialog.DoneMessage"), { variant: "success" });
                        onClose();
                        break;
                }
                setSubmiting(false);
            })
            .catch(e => {
                setViewError(e);
                setSubmiting(false);
            });
    };


    return (
        <Dialog
            open
            fullWidth
            maxWidth="md"
        >
            <MprcDialogTitleClose
                shrinkPadding
                title={t("Auth.ForgotPassDialog.Title")}
                onClose={() => onClose()}
            />
            <DialogContent style={{ minHeight: 300 }}>
                {
                    viewError
                        ? <MprcRequestErrorReport error={viewError} />
                        : (
                            <form autoComplete="on" spellCheck={false}>

                                <TextField
                                    id="performaId"
                                    autoFocus
                                    label={session.config.authOptions?.identifierInstructions ?? t("Auth.Login.IdentifierLabel")}
                                    autoComplete="performaId"
                                    margin="normal"
                                    fullWidth={true}
                                    disabled={submiting}
                                    value={authValue}
                                    slotProps={{
                                        input: {
                                            inputProps: { maxLength: 255 }
                                        }
                                    }}
                                    onKeyDown={(e) => { if (e.keyCode == 13) handleRenew(); }}
                                    onChange={
                                        (e) => {
                                            setAuthValue(e.target.value);
                                        }
                                    }
                                />
                            </form>
                        )
                }
            </DialogContent>
            <DialogActions>
                <ButtonCancel
                    variant="contained"
                    disabled={submiting}
                    onClick={() => onClose()}
                />
                {
                    viewError == null &&
                    <ButtonSend
                        color="success"
                        variant="contained"
                        disabled={submiting || (authValue ?? "").length == 0}
                        onClick={handleRenew}
                    >
                        {submiting && <MprcSpinnerIndicator />}
                    </ButtonSend>
                }
            </DialogActions>
        </Dialog>);
};
